export class Undefined {
  constructor() { }
}

export const UndefinedValue = new Undefined();
